import o from "lodash/merge";
import r from "../variants/AtriusDark.js";
import a from "./BaseDark.js";
const t = o(r, {
  // #region Springboard properties
  ...a,
  // Override or add additional theme properties here
  primaryFill: r.color.background.primary,
  primaryHover: r.color.background.primaryhover
});
export {
  t as default
};
